import React from 'react';
import {useIntl} from "react-intl";
import {shallowEqual, useSelector} from 'react-redux';
import {usePopupEditTasksContext} from "./PopupEditTasksContext";
import {StyledFieldInput} from "../../../_common/components/FieldInput";
import {StyledFieldDatepicker}  from "../../../_common/components/FieldDatepicker";
import {StyledFieldSelect} from "../../../_common/components/FieldSelect";
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalContent from '../../../_common/components/ModalContent';
import {filterOptions} from "../../../_common/utils/options";
import {integerValueCanStartFromNull} from "../../../_common/utils/changeInputValue";
import {taskStatuses} from "../../../_common/constants/options";

const TaskVisit = ({header}) => {
  const intl = useIntl();
  const prefix = 'tab-order-inspections-tasks-popup';
  const {formik} = usePopupEditTasksContext();
  const {values, setFieldValue} = formik;
  const {users} = useSelector((state) => ({users: state.usersReducer.users}), shallowEqual);
  const getFieldLabel = (text, mandatory = true) => {
    return (
      <div>
        <span>{text}</span>
        {mandatory && <span className={'text-danger'}>*</span>}
      </div>
    )
  };

  return (
    <>
      <ModalHeader header={header}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldSelect
          fieldId={'responsibleUserID'}
          onChange={(option) => setFieldValue('responsibleUserID', option.value)}
          value={filterOptions(values.responsibleUserID)(users)}
          options={users}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-responsibleUser`, defaultMessage: 'Responsible user'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldSelect
          fieldId={'taskStatusID'}
          onChange={(option) => setFieldValue('taskStatusID', option.value)}
          value={filterOptions(values.taskStatusID)(taskStatuses)}
          options={taskStatuses}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldDatepicker
          value={values.taskDueDate}
          onChange={(date) => setFieldValue('taskDueDate', new Date(date))}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-dueDate`, defaultMessage: 'Due date'}))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldInput
          fieldId={'notes'}
          value={values.notes}
          onChange={(e) => setFieldValue('notes', e.target.value)}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-notes`, defaultMessage: 'Notes'}), false)}
          customContainerStyles={'py-3'}
          icon={'/media/common/Edit_primary.svg'}
        />
        <StyledFieldInput
          fieldId={'visitContactName'}
          value={values.visitContactName}
          onChange={(e) => setFieldValue('visitContactName', e.target.value)}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-contactName`, defaultMessage: 'Contact name'}), false)}
          customContainerStyles={'py-3'}
          icon={'/media/common/User_primary.svg'}
        />
        <StyledFieldInput
          fieldId={'visitContactPhone'}
          value={values.visitContactPhone}
          onChange={(e) => setFieldValue('visitContactPhone', integerValueCanStartFromNull(e))}
          label={getFieldLabel(intl.formatMessage({id: `${prefix}-contactPhone`, defaultMessage: 'Contact phone'}), false)}
          customContainerStyles={'py-3'}
          icon={'/media/common/Phone_primary.svg'}
        />
      </ModalContent>
    </>
  );
}

export default TaskVisit;
